import type { PublicParameters } from './parameters';

/** Generated from santas-workshop-test Remote Config version 65. Do not edit. */
export const PUBLIC_PARAMETERS_RELEASE_DEFAULTS: PublicParameters = {
	"registrationEnabled": true,
	"maintenanceModeEnabled": false,
	"weatherModeEnabled": false,
	"createAccountEnabled": true,
	"messageEn": "",
	"messageEs": "",
	"admin": {
		"checkinEnabled": true,
		"onsiteRegistrationEnabled": true,
		"preRegistrationEnabled": true,
		"allowCancelRegistration": true,
		"allowChangeRegistration": true
	},
	"globalAlert": {
		"displayAlert": false,
		"titleEn": "",
		"titleEs": "",
		"messageEn": "",
		"messageEs": ""
	}
};
